/**
 * A scanned value that is an http(s) URL is never a product barcode — product
 * codes are EAN/UPC/CODE128 digits or short SKUs. QR codes printed on internal
 * documents (e.g. delivery notes) and links opened via in-app browsers encode
 * full URLs; feeding one into the product-barcode lookup only yields repeated
 * 404s while the code stays in the camera frame. Callers short-circuit the
 * lookup on a match and tell the operator it is the wrong kind of code.
 */
export function looksLikeUrl(code: string): boolean {
    return /^https?:\/\//i.test(code.trim())
}
